var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBscIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6252 53.1782C41.248 53.1782 53.102 41.3241 53.102 26.7014C53.102 12.0787 41.248 0.224609 26.6252 0.224609C12.0025 0.224609 0.148438 12.0787 0.148438 26.7014C0.148438 41.3241 12.0025 53.1782 26.6252 53.1782Z",
    fill: "#F3BA2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9862 33.8214L37.9825 33.8232L26.6259 45.1817L15.2711 33.8269L15.2656 33.8214L19.4471 29.6509L26.6259 36.8278L33.8065 29.6472L37.9862 33.8214Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9849 19.5794L33.8088 23.7554L26.6282 16.5748L19.4494 23.7518L15.2734 19.5757L26.6282 8.22095L37.9849 19.5794Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9343 22.5276L36.7578 26.7041L40.9343 30.8806L45.1108 26.7041L40.9343 22.5276Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.325 22.5251L8.14844 26.7017L12.325 30.8782L16.5015 26.7017L12.325 22.5251Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8655 26.6995H30.8673L26.629 22.4612L23.4979 25.5923L23.1386 25.9516L22.3961 26.694L22.3906 26.6995L22.3961 26.705L26.6308 30.9397L30.8691 26.7014L30.871 26.6995H30.8655Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBscIcon);
export default __webpack_public_path__ + "static/media/bscIcon.bb185babb0102d6d7af8e4fc8394d5e9.svg";
export { ForwardRef as ReactComponent };